var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBadge = function SvgBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.123 42.16S2.057 29.584 1.9 24.117C1.742 18.689 0 3.811 0 3.811s45.418-2.614 68.362-1.547c13.009.605 53.789-1.391 61.17-1.28 7.382.113 28.382-.17 31.217-.247C163.583.659 170.441 0 170.441 0s1.569 13.485 1.018 18.177c-.552 4.693.045 13.1.377 14.07.332.969.276 7.156.276 7.156s-49.416 1.337-56.599.867c-7.184-.471-46.99 2.258-59.095 1.712-12.104-.545-25.358-.024-36.701.446-11.344.47-17.594-.267-17.594-.267Z",
    fill: "#D4CAFF"
  })));
};

export default SvgBadge;